import axiosInstance from "./axiosInstance";
import { SERVER_TOKEN } from "./secret";

export const getData = async (url = '') => {
    const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // console.log('madarchod token',token);
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    try {
        const data = await axiosInstance.get(url, { headers: { "Authorization": `Bearer ${compleateToken}` } });
        return data.data;
    } catch (error) {
        // Handle MODULE_DISABLED errors gracefully
        if (error.response?.status === 403 && error.response?.data?.error === 'MODULE_DISABLED') {
            console.warn('Module disabled:', error.response.data.message);
            // Return null or throw a specific error that components can handle
            throw { 
                type: 'MODULE_DISABLED', 
                message: error.response.data.message || 'This feature is not available for your industry',
                data: error.response.data 
            };
        }
        throw error;
    }
}
export const deleteData = async (url = '') => {
    const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // console.log('madarchod token',token);
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    const data = await axiosInstance.delete(url, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}

export const getDataSimple = async (url = '') => {
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    // if(token){
    //     compleateToken = token + ','+compleateToken;
    // }
    const data = await axiosInstance.get(url, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}
export const postData = async (url = '', req) => {
    const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    try {
        const data = await axiosInstance.post(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
        return data.data;
    } catch (error) {
        // Handle MODULE_DISABLED errors gracefully
        if (error.response?.status === 403 && error.response?.data?.error === 'MODULE_DISABLED') {
            console.warn('Module disabled:', error.response.data.message);
            throw { 
                type: 'MODULE_DISABLED', 
                message: error.response.data.message || 'This feature is not available for your industry',
                data: error.response.data 
            };
        }
        throw error;
    }
}

export const postDataSimple = async (url = '', req) => {
    // const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    // if(token){
    //     compleateToken = token + ','+compleateToken;
    // }
    const data = await axiosInstance.post(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}
export const patchData = async (url = '', req) => {
    const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    const data = await axiosInstance.patch(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}

export const putData = async (url = '', req) => {
    const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    const data = await axiosInstance.put(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}

export const putDataSimple = async (url = '', req) => {
    // const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    // if(token){
    //     compleateToken = token + ','+compleateToken;
    // }
    const data = await axiosInstance.put(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}

export const deleteDataSimple = async (url = '') => {
    // const token = localStorage.getItem('token');
    // const token = cookie.load("token");
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    // if(token){
    //     compleateToken = token + ','+compleateToken;
    // }
    console.log('here token delete',compleateToken);
    const data = await axiosInstance.delete(url, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}
export const postSuperData = async (url = '', req) => {
    // const token = localStorage.getItem('token');
    const token = 'tokenSUPERtoken3485%^';
    // let compleateToken = 'tokenSuper@1';
    let compleateToken = SERVER_TOKEN;
    if(token){
        compleateToken = token + ','+compleateToken;
    }
    console.log(token);
    const data = await axiosInstance.post(url, req, { headers: { "Authorization": `Bearer ${compleateToken}` } });
    return data.data;
}